import {
  CLEAR_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES,
  SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES,
  SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES_DATA,
  UPDATE_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES,
} from "../types";

const initialState = {
  data: [],
  searchParams: {
    surname: "",
    name: "",
    midname: "",
    apcode: null,
    leName: "",
    leUnp: "",
    section: null,
    dateStart: "",
    dateEnd: "",
  },
};

export const logbookAdministrativeProceduresReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES_DATA:
      return (() => ({
        ...state,
        data: action.data,
      }))();
    case SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES:
      return (() => ({
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      }))();
    case UPDATE_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES:
      return (() => ({
        ...state,
        data: action.data,
      }))();
    case CLEAR_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES:
      return (() => ({
        ...state,
        data: action.data,
      }))();
    default:
      return state;
  }
};
